<div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="false">
    <div class="carousel-inner">
        <div *ngFor="let item of lista; let indice = index " [class.active]="indice == 0" class="carousel-item">
            <div class="d-flex h-100">
                <div class="w-50 item-img" style="cursor: pointer;" (click)="redirectnoticia(item)">
                    <img [src]="getimagembyUrl(item?.Imagem?.Url)" class="d-block img-banner" alt="...">
                </div>
                <div class="w-50 bg-area d-flex flex-column p-3">
                    <h1 class="mt-auto"  style="cursor: pointer;" (click)="redirectnoticia(item)">{{item.Title}}</h1>
                    <div class="w-75"  style="cursor: pointer;" (click)="redirectnoticia(item)">
                        <p style="font-size: 16px; text-align: justify">{{item.Resumo}}</p>
                    </div>
                    <button (click)="redirectnoticia(item)" class="btn btn-transparent mt-3 mb-auto" style="border: solid #4c6a86">
                        <!--Ler Mais-->
                    </button>
                </div>
            </div>
        </div>
    </div>
    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
    </button>
</div>